import breakpoint from '@carvana/helios-layout/breakpoint';
import { background, border, brand, text, body } from '@carvana/helios-styles';
import styled from 'styled-components';

const Background = styled.div`
  padding-top: 10px;

  ${breakpoint.sm`
    &.chicago {
      padding-top: 100px;
    }
  `}

  ${breakpoint.xl`
    &.chicago {
      padding-top: 220px;
    }
  `}
`;

const VectorWrap = styled.div`
  display: none;

  ${breakpoint.xl`
    display: block;
    margin-top: 100px;
    width: 100%;
  `}
`;

const HeroContainer = styled.div`
  position: relative;
  width: 100%;
  min-width: 340px;
  box-sizing: border-box;

  ${breakpoint.sm`
    padding-top: 60px;
  `}

  ${breakpoint.md`
    padding-top: 20px;
  `}

  ${breakpoint.lg`
    margin-left: auto;
    margin-right: auto;
  `}

  ${breakpoint.xl`
    max-width: 1440px;
    margin-top: -720px;
  `}
`;

const LogoWrapper = styled.div`
  width: 148px;
  margin: 32px auto 24px;

  ${breakpoint.sm`
    width: 166.15px;
    height: 36px;
    margin-top: 0;
    margin-left: 32px;
  `}

  ${breakpoint.md`
    width: 234px;
    height: 57px;
    margin-left: 32px;
    margin-bottom: 0;
  `}

  ${breakpoint.xl`
    padding-left: 84px;
    padding-right: 84px;
    margin: 2rem 0;
  `}
`;

const HeadingWrapper = styled.div`
  height: 100%;
  padding: 0 24px 16px 24px;

  ${breakpoint.sm`
    width: 432px;
    padding: 0 32px;
  `}

  ${breakpoint.md`
    width: 600px;
  `}

  ${breakpoint.xl`
    padding: 0 84px;
  `}
`;

const Heading = styled.h1`
  text-align: center;
  font-family: 'Brandon for Carvana';
  font-weight: 900;
  letter-spacing: -0.035rem;
  text-transform: uppercase;
  font-size: 32px;
  line-height: 32px;
  color: ${text.strong};

  ${breakpoint.sm`
    font-size: 56px;
    line-height: 52px;
    ${brand.sm};
    text-align: left;
  `};

  ${breakpoint.md`
    ${brand.lg};
    text-align: left;
    width: 624px; 
    margin-top: 20px;
  `};
`;

const Subheading = styled.p`
  ${body.regular.lg};
  color: ${text.strong};
  margin-top: 8px;
  text-align: center;

  ${breakpoint.sm`
    text-align: left;
  `}

  ${breakpoint.md`
    ${body.regular.xl};
  `}
`;

const ImageWrapper = styled.div`
  display: block;
  width: 100%;
  height: 188px;
  position: relative;
  margin-left: auto;
  right: 0;

  ${breakpoint.sm`
    height: 238px;
  `};

  ${breakpoint.md`
    height: 322;
    padding-bottom: 112px;
  `};

  ${breakpoint.xl`
    display: none;
  `}
`;

const LeftFillerHolder = styled.div`
  position: absolute;
  height: 42px;
  margin-top: 105px;
  margin-left: -40px;

  ${breakpoint.sm`
    margin-top: 125.5px;

    & svg {
      width: calc(100vw - 400px);
    }
  `}

  ${breakpoint.md`
    margin-top: 245.5px;
    margin-left: -200px;

    & svg {
      width: calc(100vw - 400px);
    } 
  `}

  ${breakpoint.xl`
    display: none;
  `}
`;

const ImageContainer = styled.div`
  ${breakpoint.sm`
    margin-top: -34px;
  `}

  ${breakpoint.md`
    margin-top: -13px;
  `}

  ${breakpoint.xl`
    margin-top: -165px;
  `}
`;

const CardWrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  min-width: 340px;
  width: 100%;
  z-index: 10;
  padding: 0 24px;

  ${breakpoint.sm`
    margin-top: 20px;
    padding: 0 32px;
  `}

  ${breakpoint.md`
    position: absolute;
    max-width: 1272px;
    top: 285px;
    margin-top: -20px;

    &.extra-space {
      margin-top: 20px; 
    }
  `}

  ${breakpoint.xl`
    top: 330px;
    left: 50px;
  `}
`;

const Card = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 6px 16px;
  border: 1px solid ${border.weak};
  border-radius: 16px;
  background-color: ${background.default};

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;

  ${breakpoint.md`
    width: 468px;
    max-height: 286px;
  `}

  ${breakpoint.xl`
    width: 516px;
  `}

  & button:not([data-cv-test="heroVinEntryLinkButton"]) {
    width: 100%;
  }
`;

const ImageRightFiller = styled.div`
  height: 40.69px;
  width: 50px;
  background: blue;
  position: relative;
`;

const VehicleImageWrapper = styled.div`
  height: 200px;
  width: 356px;
  position: relative;
  margin-top: -200px;
  margin-left: auto;
  right: 0px;
  top: 10px;

  ${breakpoint.sm`
    margin-top: -250px;
    height: 250px;
    width: 444px;
    top: 42px;
    right: -15px;
  `}

  ${breakpoint.md`
    height: 380px;
    width: 676px;
    top: -110px;
    right: -73px;
  `}

  ${breakpoint.xl`
    height: 540px;
    width: 960px;
    top: 180px;
  `}
`;

const PatternWrapper = styled.div`
  ${breakpoint.xl`
    width: 900px;
    height: 900px;
    top: 750px;
    position: relative;
    margin-right: auto;
    margin-left: auto;
    margin-top: -900px;
    right: 0;
    left: 300px;
  `}
`;

export {
  Background,
  Card,
  CardWrapper,
  Heading,
  HeadingWrapper,
  HeroContainer,
  ImageWrapper,
  LogoWrapper,
  LeftFillerHolder,
  PatternWrapper,
  ImageRightFiller,
  ImageContainer,
  Subheading,
  VectorWrap,
  VehicleImageWrapper
};
